<ng-template #groupLabel let-save>
    @let state = save.attributes.content.state;
    @let members = getSaveMembers(save);
    <span>{{ state.group_name || ('iackathon.outdated_save' | translate) }}</span>
    <span>
        @if (members.length) {
            @for (member of members; track member.id) {
            <span>{{ member.name }}</span>
            <span>{{ $last ? null : ', ' }}</span>
            }
        } @else {
            <span>{{ save.attributes.owner.username }}</span>
        }
    </span>
</ng-template>

<div class="iackathon-group-details-page__header">
    <a class="iackathon-group-details-page__back-link"
        [routerLink]="['/iackathon-groups']">
        <mat-icon svgIcon="arrow_left_alt_rounded"></mat-icon>
        <span>{{ 'iackathon.back' | translate }}</span>
    </a>
    <h1 class="iackathon-group-details-page__title">
        {{ 'iackathon.group_details' | translate }}
    </h1>
</div>

@if (isLoading()) {
      <mat-spinner></mat-spinner>
} @else {
    <div class="iackathon-group-details-page__content">
        <mat-form-field class="iackathon-group-details-page__group-field">
            <mat-label>{{ 'iackathon.select_group' | translate }}</mat-label>
            <mat-select [value]="selectedSave()?.id"
                        (valueChange)="onSelectSaveChange($event)"
                        panelClass="iackathon-group-details-page__select-panel">
                <mat-select-trigger>
                    @if (selectedSave(); as save) {
                        <ng-container [ngTemplateOutlet]="groupLabel"
                                      [ngTemplateOutletContext]="{ $implicit: save }">
                        </ng-container>
                    }
                </mat-select-trigger>
                @for (group of groupSaves(); track group.id) {
                    <mat-option [value]="group.id"
                                [disabled]="!group.attributes.content.state.group_name">
                        <ng-container [ngTemplateOutlet]="groupLabel"
                                      [ngTemplateOutletContext]="{ $implicit: group }">
                        </ng-container>
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <app-iackathon-progress-viewer [save]="selectedSave()"
                                       [(activeState)]="activeStep">
        </app-iackathon-progress-viewer>
    </div>
    <app-iackathon-step-details id="iackathon-step-details"
                                role="region"
                                [ariaLabel]="stepLabelKeys[activeStep()] | translate"
                                [save]="selectedSave()"
                                [step]="activeStep()">
    </app-iackathon-step-details>
}